import { render, staticRenderFns } from "./DetailFaqs.vue?vue&type=template&id=3ee2dfe3"
import script from "./DetailFaqs.vue?vue&type=script&lang=js"
export * from "./DetailFaqs.vue?vue&type=script&lang=js"
import style0 from "./DetailFaqs.vue?vue&type=style&index=0&id=3ee2dfe3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports